// extracted by mini-css-extract-plugin
export default {"root":"order-book-table_root__78dtE"};